import {StrategyColumnConfig, strategyColumnPresets} from "./StrategyColumns";
import {LocalStorageService} from "../../../types/NgStorage";
import {StrategyColumnSelectController} from "./StrategyColumnSelectController";
import {Observable} from "rxjs/Observable";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {NgAsideService, NgAsideSettings} from "../../../types/NgAside";
import {StringKeyed} from "../../../types/GenericTypes";
import {ObjectUtil} from "../../../js/util/ObjectUtil";

export class StrategyColumnService {

    public static id = "strategyColumnService";

    private static STORAGE_KEY = "strategy-builder-columns";

    /** @ngInject */
    public constructor(private $aside: NgAsideService,
                       private $localStorage: LocalStorageService,
                       private terms: StringKeyed<any>,
                       private screenSize: any) {

    }

    public open(currentColumns: StrategyColumnConfig): Observable<StringKeyed<any>> {
        const initial = this.initialSettings(currentColumns);
        const changes = new BehaviorSubject(initial);
        const options: NgAsideSettings = {
            templateUrl: "app/strategybuilder/services/column-def/StrategyColumnSelectTemplate.html",
            controller: StrategyColumnSelectController,
            controllerAs: "ctrl",
            windowClass: "strategy-column-select",
            size: "sm",
            resolve: {
                changes: () => changes
            },
            placement: "left"
        };
        const instance = this.$aside.open(options);
        const modalResult = instance.result;

        const complete = Observable.fromPromise(modalResult);
        return changes.takeUntil(complete)
                      .map((columns) => this.extractVisibility(columns))
                      .do(columns => this.save(columns));
    }

    private initialSettings(current: StrategyColumnConfig) {
        const stripped = this.extractVisibility(current);
        const defaultSettings = this.defaultSettings();
        return ObjectUtil.merge({}, defaultSettings, stripped);
    }

    private extractVisibility(columnDefs: StrategyColumnConfig): StringKeyed {
        return Object.keys(columnDefs)
                     .map((key: keyof StrategyColumnConfig) => {
                         const def = columnDefs[key];
                         return {[key]: {visible: def.visible}};
                     })
                     .reduce((acc, next) => Object.assign(acc, next), {});
    }

    private save(columnDefs: StringKeyed<any>) {
        this.$localStorage[StrategyColumnService.STORAGE_KEY] = columnDefs;
    }

    public current(): StrategyColumnConfig {
        const saved = this.$localStorage[StrategyColumnService.STORAGE_KEY];
        if (saved != null) {
            return saved;
        } else {
            return this.defaultSettings();
        }
    }

    private defaultSettings(): StrategyColumnConfig {
        const presets = strategyColumnPresets(this.terms);
        if (this.screenSize.is("xs")) {
            return presets.mobile.columns;
        } else if (this.screenSize.is("sm")) {
            return presets.tablet.columns;
        } else {
            return presets.desktop.columns;
        }
    }
}
